import {
    CREATE_CHANNEL,
    GET_CHANNELS_OVERVIEW_DATA,
    GET_TABLE_OVERVIEW_DATA,
    RE_UPLOAD_FILE,
    RETRY_STEP,
    UPLOAD_FILE,
} from '../queries.ts';
import DocumentOverview from '../../../document/pages/Overview';
import * as constants from '../constants.ts';
import { DocumentType } from '../../../document/constants.ts';

const Overview = (props) => {
    const documentConfiguration = {
        documentType: DocumentType.OrderConfirmation,
        documentTypeName: 'orderConfirmation',
        activeTab: 'order-confirmation',
        constants: constants,
        CREATE_CHANNEL: CREATE_CHANNEL,
        GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
        GET_TABLE_OVERVIEW_DATA: GET_TABLE_OVERVIEW_DATA,
        RETRY_STEP: RETRY_STEP,
        UPLOAD_FILE: UPLOAD_FILE,
        RE_UPLOAD_FILE: RE_UPLOAD_FILE,
        // Document matching information
        documentMatchingValidationKey: 'order_matching',
        documentMatchingFieldName: 'orderNumber',
    };

    return <DocumentOverview documentConfiguration={documentConfiguration} {...props} />;
};

export default Overview;
